import type { RestaurantStatus } from '../graphql/graphql'

interface NoindexInput {
  isTest: boolean
  status: RestaurantStatus
}

// 以下の条件の場合はnoindex
//   1. テスト店舗
//   2. 店舗ステータスが「公開中」「一時停止中」以外のステータスの場合
// https://github.com/ikyucom/restaurant2/blob/c95493eb0f5509d73d1ad4b6cd64b9b102403e43/nuxt/store/restaurants/~restaurant.ts#L266-L281
export function noindex({ isTest, status }: NoindexInput): boolean {
  return isTest || !(status === 'OPEN' || status === 'SUSPENDED')
}
